// import { FormattedMessage, injectIntl } from "react-intl";

// const InjectMassage = props => <FormattedMessage {...props} />;

// export default injectIntl(InjectMassage, {
//   withRef: false
// });

import { FormattedMessage } from "react-intl";

export default function InjectMessage(props) {
  return <FormattedMessage {...props} />;
}